import { render, staticRenderFns } from "./class_add.vue?vue&type=template&id=c66960b4&scoped=true&"
import script from "./class_add.vue?vue&type=script&lang=js&"
export * from "./class_add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66960b4",
  null
  
)

export default component.exports